// @flow

import removeOrderCaveat from '../../../Services/removeOrderCaveat';
import type { RemoveOrderCaveatParams } from '../../../types';

export default (params: RemoveOrderCaveatParams) => async (dispatch: Function) => dispatch(removeOrderCaveat(params))